/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

/*****************************************************
'PRIMARY TEXT ONLY' && 'PRIMARY TEXT ICON' BUTTON TYPE
*****************************************************/
:host {
  --gxg-button-icon-size: 20px;
  display: inline-block;
  line-height: 0;
  position: relative;
}
:host .ghost-icon {
  width: 0;
}

:host(.button) .button-native {
  width: 100%;
  height: 20px;
  --svg-icon-regular-scale: var(
    --svg-icon-small-scale
  );
  position: relative;
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
  background: var(--color-primary-enabled);
  border: 0;
  box-shadow: inset 0px 0px 0px 1px transparent;
  border-radius: var(--border-radius-xs);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-top: 2.5px;
  padding-right: var(--spacing-comp-03);
  padding-bottom: 2.5px;
  padding-left: var(--spacing-comp-03);
  line-height: var(--line-height-regular);
  border: 1px solid transparent;
  /*button styles are included on a mixin, because they are used on both, gxg-button, and gxg-button-group elements*/
}
:host(.button) .button-native:hover:not([disabled]) {
  background: var(--color-primary-hover);
  cursor: pointer;
}
:host(.button) .button-native:focus:not([disabled]):not(.no-tab-index) {
  background: var(--color-primary-enabled);
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
:host(.button) .button-native:active:not([disabled]) {
  background: var(--color-primary-active);
}

:host(.button.button--disabled) .button-native {
  background: var(--gxg-background-color--disabled);
  color: var(--color-primary-disabled);
  pointer-events: none;
}

:host(.button.button--disabled) {
  pointer-events: none;
}

/*********************************
PRIMARY
*********************************/
:host(.button--primary) {
  --gxg-border-color--focused: var(--color-primary-active--inverted);
}

/*********************************
PRIMARY 'TEXT ONLY' BUTTON TYPE
*********************************/
:host(.button--primary-text-only) .button-native {
  color: var(--color-on-primary);
  padding-inline-start: var(--spacing-comp-04);
  padding-inline-end: var(--spacing-comp-04);
}

:host(.button--primary-text-only.button--disabled) .button-native {
  color: var(--color-on-disabled);
}

/*********************************
PRIMARY 'TEXT + ICON' BUTTON TYPE
*********************************/
:host(.button--primary-text-icon) .button-native {
  color: var(--color-on-primary);
  padding-inline-start: var(--spacing-comp-01);
  padding-inline-end: var(--spacing-comp-02);
}
:host(.button--primary-text-icon) .button-native gxg-icon:not(.ghost-icon) {
  padding-inline-end: var(--spacing-comp-01);
}

:host(.button--primary-text-icon.button--disabled) .button-native {
  color: var(--color-on-disabled);
}

/*********************************
'PRIMARY ICON ONLY' BUTTON TYPE
*********************************/
:host(.button--primary-icon-only) .button-native {
  background: var(--color-primary-enabled);
  color: var(--color-on-primary);
}
:host(.button--primary-icon-only) .button-native:hover:not([disabled]) {
  background: var(--color-primary-hover);
  color: var(--color-primary-hover);
}
:host(.button--primary-icon-only) .button-native:focus:not([disabled]):not(.no-tab-index) {
  background: var(--color-primary-enabled);
  color: var(--color-primary-hover);
}
:host(.button--primary-icon-only) .button-native:active:not([disabled]) {
  background: var(--color-primary-active);
  color: var(--color-on-primary);
}
:host(.button--primary-icon-only) .button-native:focus {
  outline: none;
}

/*********************************
SECONDARY 'TEXT ONLY' BUTTON TYPE
*********************************/
:host(.button--secondary-text-only) .button-native {
  background: transparent;
  padding-inline-start: var(--spacing-comp-04);
  padding-inline-end: var(--spacing-comp-04);
}
:host(.button--secondary-text-only) .button-native:hover:not([disabled]) {
  color: var(--color-primary-hover);
  background: transparent;
}
:host(.button--secondary-text-only) .button-native:focus:not([disabled]):not(.no-tab-index) {
  color: var(--color-primary-active);
  background: transparent;
}
:host(.button--secondary-text-only) .button-native:active:not([disabled]) {
  color: var(--color-primary-active);
  box-shadow: none;
}
:host(.button--secondary-text-only) .button-native:focus {
  outline: none;
}

:host(.button--secondary-text-only.button--disabled) .button-native {
  background: transparent;
  color: var(--color-primary-disabled);
}

/*********************************
SECONDARY 'TEXT ICON' BUTTON TYPE
*********************************/
:host(.button--secondary-text-icon) .button-native {
  background: transparent;
  padding-inline-start: 0;
  padding-inline-start: var(--spacing-comp-01);
  padding-inline-end: var(--spacing-comp-02);
}
:host(.button--secondary-text-icon) .button-native gxg-icon:not(.ghost-icon) {
  padding-inline-end: var(--spacing-comp-01);
}
:host(.button--secondary-text-icon) .button-native:hover:not([disabled]) {
  color: var(--color-primary-hover);
  background: transparent;
}
:host(.button--secondary-text-icon) .button-native:focus:not([disabled]):not(.no-tab-index) {
  color: var(--color-primary-active);
  background: transparent;
}
:host(.button--secondary-text-icon) .button-native:active:not([disabled]) {
  color: var(--color-primary-active);
  box-shadow: none;
}

:host(.button--secondary-text-icon.button--disabled) .button-native {
  background: transparent;
  color: var(--color-primary-disabled);
}
:host(.button--secondary-text-icon.button--disabled) .button-native gxg-icon {
  --icon-color: var(--color-primary-disabled);
}

/*********************************
'SECONDARY ICON ONLY' BUTTON TYPE
*********************************/
:host(.button--secondary-icon-only) .button-native {
  background: transparent;
}
:host(.button--secondary-icon-only) .button-native:hover:not([disabled]) {
  background: transparent;
}
:host(.button--secondary-icon-only) .button-native:focus:not([disabled]):not(.no-tab-index) {
  background: transparent;
}
:host(.button--secondary-icon-only) .button-native:active:not([disabled]) {
  background: transparent;
}

:host(.button--secondary-icon-only.button--disabled) .button-native {
  background: transparent;
}

/*********************************
'OUTLINED' BUTTON TYPE
*********************************/
:host(.button--outlined) .button-native,
:host(.button--outlined-text-icon) .button-native {
  border-color: var(--color-primary-enabled);
  background: var(--color-background);
  padding-inline-start: var(--spacing-comp-04);
  padding-inline-end: var(--spacing-comp-04);
}
:host(.button--outlined) .button-native:hover:not([disabled]),
:host(.button--outlined-text-icon) .button-native:hover:not([disabled]) {
  color: var(--color-primary-hover);
  border-color: var(--color-primary-hover);
  background: var(--color-primary-hover-opacity-01);
}
:host(.button--outlined) .button-native:focus:not([disabled]):not(.no-tab-index),
:host(.button--outlined-text-icon) .button-native:focus:not([disabled]):not(.no-tab-index) {
  color: var(--color-primary-active);
  background: transparent;
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
:host(.button--outlined) .button-native:active:not([disabled]),
:host(.button--outlined-text-icon) .button-native:active:not([disabled]) {
  color: var(--color-primary-active);
  background: transparent;
}
:host(.button--outlined) .button-native gxg-icon:not(.ghost-icon),
:host(.button--outlined-text-icon) .button-native gxg-icon:not(.ghost-icon) {
  padding-inline-end: var(--spacing-comp-01);
}

:host(.button--outlined.button--disabled) .button-native,
:host(.button--outlined-text-icon.button--disabled) .button-native {
  border-color: var(--gxg-border-color--disabled);
  background: var(--color-transparent);
  color: var(--color-primary-disabled);
}

:host(.button--outlined-text-icon) .button-native {
  padding-inline-start: var(--spacing-comp-03);
}

/*********************************
'TERTIARY' BUTTON TYPE
*********************************/
:host(.button--tertiary) .button-native {
  background: transparent;
  padding-inline-end: 0;
  padding-inline-start: 0;
}
:host(.button--tertiary) .button-native:hover:not([disabled]) {
  background: transparent;
}
:host(.button--tertiary) .button-native:hover:not([disabled]) gxg-icon {
  --color-on-background: var(--gray-05);
}
:host(.button--tertiary) .button-native:focus:not([disabled]):not(.no-tab-index) {
  background: transparent;
  outline: var(--border-width-md) solid var(--gxg-border-color--focused);
  outline-offset: -2px;
}
:host(.button--tertiary) .button-native:active:not([disabled]) {
  background: transparent;
}

:host(.button--tertiary.button--disabled) .button-native {
  background: transparent;
}

:host(.button--fullwidth) {
  display: block;
}
:host(.button--fullwidth) .button-native {
  width: 100%;
}

:host(.button--fit) .button-native {
  height: 100% !important;
  width: 100% !important;
}

/********************************************************************
ICON TOOLTIP (ONLY FOR PRIMARY-ICON-ONLY & SECONDARY-ICON-ONLY TYPES)
*********************************************************************/
:host .icon-tooltip {
  position: absolute;
  border-width: 0.5px;
  border-style: solid;
  border-color: var(--gray-04);
  color: var(--color-on-background);
  background-color: var(--gray-01);
  font-size: 8px;
  font-weight: var(--font-weight-regular);
  font-family: var(--font-family-primary);
  padding: 1px 5px;
  width: max-content;
  left: 0;
  top: 20px;
  display: none;
  opacity: 0;
  transition-property: opacity;
  transition-duration: var(--ui-animaton-speed);
  transition-timing-function: ease;
}

:host(.display-tooltip) .icon-tooltip {
  display: block;
}

:host(.show-tooltip) .icon-tooltip {
  opacity: 1;
}

/*********************************
ICON ONLY
*********************************/
:host(.button--icon-only) {
  width: var(--gxg-button-icon-size);
  height: var(--gxg-button-icon-size);
}
:host(.button--icon-only) .button-native {
  padding: 0;
}

/*********************************
GRAB ATTENTION ANIMATION
*********************************/
:host(.button--primary-text-only[grab-attention]:not([disabled])) .button-native:not(:hover),
:host(.button--primary-text-icon[grab-attention]:not([disabled])) .button-native:not(:hover),
:host(.button--primary-icon-only[grab-attention]:not([disabled])) .button-native:not(:hover) {
  animation-name: grabAttentionPrimary;
  animation-duration: 500ms;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes grabAttentionPrimary {
  from {
    background-color: var(--color-primary-enabled);
  }
  to {
    background-color: var(--color-primary-hover);
  }
}
/*********************************************
LARGE VERSION (html tag has 'gxg-large' class)
**********************************************/
:host(.large) {
  --gxg-button-icon-size: 24px;
}

:host(.large) .button-native {
  height: var(--spacing-comp-05);
  font-size: var(--font-size-lg) !important;
}

:host(.button--primary-text-icon.large) .button-native {
  padding-inline-start: var(--spacing-comp-02);
  padding-inline-end: var(--spacing-comp-03);
}

:host(.button--primary-icon-only.large) .button-native {
  height: var(--spacing-comp-05);
}

:host(.button--secondary-text-icon.large) .button-native {
  padding-inline-start: var(--spacing-comp-02);
  padding-inline-end: var(--spacing-comp-03);
}

:host(.button--secondary-icon-only.large) .button-native {
  height: var(--spacing-comp-05);
}

:host(.button--tertiary.large) .button-native {
  height: var(--spacing-comp-05);
}